import React from "react";
import "../../assets/css/header.css";
import LanguageSwitcher from "../../components/ui/LanguageSwitcher/LanguageSwitcher";

const HeaderDesktop = ({ title, onBack, showIcon }) => {
  return (
    <header className="main-header">
      <div className="tHead" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div className="tTitle">
          <h2 className="text-md">{title}</h2>
        </div>
        <LanguageSwitcher /> {/* ✅ Added here */}
      </div>
    </header>
  );
};

export default HeaderDesktop;
